import { useNetwork } from "@utils/useNetwork";
import { useLanguage } from "@languageProvider";
import { Spacing, Icon, Colors } from "@styles";
import { StyleSheet, Text, View } from "react-native";
import { useTheme } from "@themeProvider";

export const NetworkBanner = () => {
  const network = useNetwork();
  const { translate: t } = useLanguage();
  const { useColor } = useTheme();
  const [title, body, warning] = useColor(["title", "body", "warning"]);

  return (
    <View
      pointerEvents="none"
      style={[
        {
          position: "absolute",
          zIndex: 2,
          left: 0,
          right: 0,
          top: 0,
          bottom: 0,
          justifyContent: "flex-end",
          paddingBottom: Spacing.MARGINS
        }, !network?.isConnected && {
          backgroundColor: Colors.setOpacity("#000000", 0.25),
        },
      ]}
    >
      {!network?.isConnected && (
        <View
          pointerEvents="none"
          style={[
            {
              backgroundColor: warning,
              borderWidth: StyleSheet.hairlineWidth,
              borderColor: Colors.setOpacity("#000000", 0.1),
              alignSelf: "center",
              zIndex: 1,
              paddingHorizontal: Spacing.M,
              paddingVertical: Spacing.S,
              borderRadius: 24,
              elevation: 3,
              flexDirection: "row",
              alignItems: "center",
              gap: Spacing.M,
            },
          ]}
        >
          <Icon name="warning" size={48} color={"black"} />
          <View style={{ flex: 1 }}>
            <Text
              style={[
                {
                  fontSize: 16,
                  fontWeight: "bold",
                  color: title,
                },
              ]}
            >
              {t("noInternetConnection")}
            </Text>
            <Text
              style={[
                {
                  fontSize: 14,
                  color: body,
                },
              ]}
            >
              {t("noInternetConnectionExplanation")}
            </Text>
          </View>
        </View>
      )}
    </View>
  );
};
